import React from 'react'

/*eslint-disable */

import Rotation from '../../../controllers/rotationMobile.controller';

interface Camera {
    _isMounted: any,
    _rotationControl: any
}

interface Props {
    useSubdirectories?: boolean,
    links?: any,
    is180?: any,
    secondary?: boolean,
    onReady?: any,
    isPreTransition?: any,
    initFramePOI?: any,
    shouldRotate?: any,
    rotateForBubble?: any,
    bubbleAngle?: any,
    handleStartTransicion?: any,
    handleRotateForBubbleEnded?: any,
    handleAngleUpdate?: any,
    notifyZoom?: any,
    notifyLeftOffset?: any,
    notifyTopOffset?: any,
    notifyZoomAndOffsets?: any,
    hasControl?: boolean,
    handleHideTooltip?: any
}

interface State {
    images: any,
    loading: boolean,
    tempImages: any,
    transition: boolean
    loadedImages: number,
    cache: any,
    loadAfterRotation: boolean
}

class Camera extends React.Component<Props,State>{

    constructor(props: Props){
        super(props);
        this.state = {
            images: [],
            loading: false,
            tempImages: [],
            transition: false,
            loadedImages: 0,
            cache: {},
            loadAfterRotation: false
        }

        this._rotationControl = React.createRef()
    }

    componentDidMount(): void {
        this._isMounted = true

        this.setState({
            loading: true,
        })

        if(this.state.images.length === 0){
            this.loadImages(0)
        }
    }

    componentWillUnmount(): void {
        this._isMounted = false
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        let {links, isPreTransition} = this.props

        if(prevProps.links !== links){
            if(this.props.secondary){
                this.setState({
                    images: [],
                    loading: true,
                    cache: {},
                    loadedImages: 0,
                    transition: true
                }, () => {
                    if(this.state.images.length === 0){
                        this.loadImages(0)
                    }
                })
            }

            if(this.props.shouldRotate){
                this.setState({
                    loadAfterRotation: true
                })
            }

            else{
                this.loadImages(0)
            }
        }

        if(prevProps.initFramePOI !== this.props.initFramePOI){
            this._rotationControl.current.moveTo(this.props.initFramePOI)
        }

        if(this.props.secondary){
            if(prevProps.rotateForBubble !== this.props.rotateForBubble){
                if(this.props.rotateForBubble){
                    this._rotationControl.current.moveTo(this.props.bubbleAngle)
                }
            }
            else {
                if(prevProps.isPreTransition !== this.props.isPreTransition){
                    if(isPreTransition){
                        this._rotationControl.current.moveTo(this.props.initFramePOI)
                    }
                }
            }
        }
    }

    loadImages = (offset: number) => {
        let {links} = this.props

        this.setState({
            tempImages: links.filter((value: any, i: number) => {
                return this.props.is180 ? 36 : 72
            }),
            loading: false,
            transition: false
        }, () => {
            this.setState({
                loading: true
            })
            this.cacheImages(this.state.tempImages)
        })
    }

    cacheImages(srcArray: any){
        let self = this

        srcArray.forEach((src: any) => {
            new Promise((resolve: any, reject: any) => {
                const img = new Image();
                img.src = src

                var stateCopy: any = Object.assign({}, self.state);
                stateCopy.cache[src] = img;
                self.setState(stateCopy)
                img.onload = (event) => {
                    if(!self._isMounted){
                        return
                    }

                    this.setState((prevState) => ({
                        loadedImages: prevState.loadedImages + 1
                    }), 
                    () => {
                        self.handleImageLoaded(this.state.loadedImages);
                    })

                    this.props.onReady()
                }
                img.onerror = (err) => {
                    reject()
                }
            }).catch((e: any) => {

            })
        })
        this.setState({
            loading: false
        })
    }

    handleImageLoaded = (loadedImages: any) => {

        if(loadedImages % (100) === 0){
            var ArrayImages = []
            for(let i = 0; i < this.state.tempImages.length; i++){
                ArrayImages.push(this.state.cache[this.state.tempImages[i]])
            }
            this.setState({
                images:  ArrayImages,
                loading: false
            })
        }
        if(loadedImages % (50) === 0){
            var ArrayImages = []
            for(let i = 0; i < this.state.tempImages.length; i++){
                ArrayImages.push(this.state.cache[this.state.tempImages[i]])
            }
            this.setState({
                images:  ArrayImages,
                loading: false
            })
        }
        if(loadedImages % (25) === 0){
            var ArrayImages = []
            for(let i = 0; i < this.state.tempImages.length; i++){
                ArrayImages.push(this.state.cache[this.state.tempImages[i]])
            }
            this.setState({
                images:  ArrayImages,
                loading: false
            })
        }
        if(loadedImages % (this.props.is180 ? 36 : 72) === 0){
            var ArrayImages = []
            for(let i = 0; i < this.state.tempImages.length; i++){
                ArrayImages.push(this.state.cache[this.state.tempImages[i]])
            }
            this.setState({
                images:  ArrayImages,
                loading: false
            })
        }
    }

    renderImage(index: number){
            return(
                <img
                    src={this.state.images[index].src}
                    key={'img'+index}
                    alt=""
                />
            )
    }

    onRotationEnded = () => {
        let { handleStartTransicion } = this.props

        handleStartTransicion()
    }

    onChange = (current: number) => {
        if(!this._isMounted){
            return;
        }

        if(this.props.handleAngleUpdate){
            this.props.handleAngleUpdate(current)
        }
    }

    render(): React.ReactNode {
        return(
            <div className='camera-component'>
                {
                    this._isMounted ?
                    <Rotation
                        cycle={!this.props.is180}
                        is180={this.props.is180}
                        reverse={true}
                        ref={this._rotationControl}
                        onRotationEnded={this.onRotationEnded}
                        className={'camera-frames'}
                        onChange = {this.onChange}
                        initFrame = {this.props.secondary ? this.props.initFramePOI : 0}
                        secondary = {this.props.secondary}
                        notifyZoom = {this.props.notifyZoom}
                        notifyLeftOffset = {this.props.notifyLeftOffset}
                        notifyTopOffset = {this.props.notifyTopOffset}
                        notifyZoomAndOffsets = {this.props.notifyZoomAndOffsets}
                        handleHideTooltip = {this.props.handleHideTooltip}
                    >
                        {
                        this.state.loading ? 
                            <p>Loading</p>:
                            this.state.images.map((url: any, index: number) => this.renderImage(index))
                        }
                    </Rotation>:null
                }
            </div>
        )
    }
}

export default Camera